var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 701,
    viewBox: "0 0 501 701",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.501 1.00087H138.501C136.861 0.980888 135.236 1.30421 133.729 1.95005C132.222 2.59588 130.867 3.54994 129.751 4.75088L4.75088 129.751C3.54994 130.867 2.59588 132.222 1.95004 133.729C1.3042 135.236 0.980888 136.861 1.00087 138.501V638.501C1.00087 655.077 7.58568 670.974 19.3067 682.695C31.0277 694.416 46.9248 701.001 63.5009 701.001H438.501C455.077 701.001 470.974 694.416 482.695 682.695C494.416 670.974 501.001 655.077 501.001 638.501V63.5009C501.001 46.9248 494.416 31.0277 482.695 19.3067C470.974 7.58568 455.077 1.00087 438.501 1.00087Z",
    fill: "url(#paint0_linear_2267_420)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.359 1.04767C141.106 0.02656 138.588 -0.257327 136.164 0.236459C133.74 0.730245 131.533 1.97651 129.859 3.79766L4.8589 128.798C2.64467 130.401 1.05877 132.726 0.374284 135.373C-0.310196 138.019 -0.0504147 140.822 1.1089 143.298C2.10581 145.745 3.85262 147.813 6.09846 149.206C8.34431 150.598 10.9737 151.243 13.6089 151.048H88.6089C96.8165 151.048 104.944 149.431 112.527 146.29C120.109 143.149 126.999 138.546 132.803 132.742C138.607 126.938 143.21 120.048 146.351 112.465C149.492 104.883 151.109 96.7553 151.109 88.5477V13.5477C151.304 10.9124 150.659 8.28308 149.267 6.03723C147.874 3.79139 145.806 2.04458 143.359 1.04767Z",
    fill: "url(#paint1_linear_2267_420)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M403.633 326.339L388.16 392.336C374.897 449.333 348.688 472.385 299.427 467.648C291.533 467.017 283.007 465.596 273.849 463.385L247.324 457.07C181.485 441.439 161.118 408.914 176.591 342.918L192.064 276.763C195.222 263.342 199.011 251.659 203.747 242.028C222.22 203.819 253.64 193.556 306.374 206.029L332.741 212.187C398.896 227.66 419.106 260.343 403.633 326.339Z",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M299.422 467.65C289.633 474.281 277.318 479.807 262.318 484.702L237.372 492.912C174.691 513.121 141.693 496.228 121.325 433.546L101.116 371.181C80.9061 308.5 97.6421 275.343 160.323 255.134L185.269 246.924C191.743 244.871 197.9 243.135 203.742 242.029C199.006 251.66 195.216 263.344 192.059 276.764L176.586 342.919C161.113 408.916 181.48 441.441 247.319 457.072L273.844 463.387C283.002 465.597 291.527 467.018 299.422 467.65Z",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M261.218 296.187L337.793 315.607",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M245.745 357.284L291.532 368.967",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2267_420",
    x1: 17.2509,
    y1: 117.251,
    x2: 532.751,
    y2: 632.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00916E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2267_420",
    x1: 1.1089,
    y1: 76.0477,
    x2: 151.109,
    y2: 76.0477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00916E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007758"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.504af7154b879f97ecdd51cbd212b951.svg";
export { ForwardRef as ReactComponent };